"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceSortFieldToJSON = exports.AudienceSortFieldFromJSONTyped = exports.AudienceSortFieldFromJSON = exports.AudienceSortField = void 0;
/**
 *
 * @export
 */
exports.AudienceSortField = {
    Name: 'NAME',
    UpdatedAt: 'UPDATED_AT'
};
function AudienceSortFieldFromJSON(json) {
    return AudienceSortFieldFromJSONTyped(json, false);
}
exports.AudienceSortFieldFromJSON = AudienceSortFieldFromJSON;
function AudienceSortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AudienceSortFieldFromJSONTyped = AudienceSortFieldFromJSONTyped;
function AudienceSortFieldToJSON(value) {
    return value;
}
exports.AudienceSortFieldToJSON = AudienceSortFieldToJSON;
